<a (click)="click()" aria-label="Toggle Image">
  <img [src]="ActiveImage" *ngIf="Model" alt="Active State">
  <img [src]="InactiveImage" *ngIf="!Model" alt=" Inactive State">
</a>